document.addEventListener('DOMContentLoaded', function() {
  const unitSwitchers = document.querySelectorAll('.product-form__unit-switcher');
  
  unitSwitchers.forEach(function(switcher) {
    const metricBtn = switcher.querySelector('[data-unit="metric"]');
    const imperialBtn = switcher.querySelector('[data-unit="imperial"]');
    const variantPicker = switcher.closest('variant-picker');
    
    if (!metricBtn || !imperialBtn || !variantPicker) return;
    
    const cmLabels = variantPicker.querySelectorAll('.variant-option__button-label--size-cm');
    const inchLabels = variantPicker.querySelectorAll('.variant-option__button-label--size-inch');
    
    function switchToMetric() {
      metricBtn.classList.add('is-active');
      imperialBtn.classList.remove('is-active');
      
      cmLabels.forEach(function(label) {
        label.style.display = '';
      });
      inchLabels.forEach(function(label) {
        label.style.display = 'none';
      });
      
      localStorage.setItem('unitPreference', 'metric');
    }
    
    function switchToImperial() {
      imperialBtn.classList.add('is-active');
      metricBtn.classList.remove('is-active');
      
      cmLabels.forEach(function(label) {
        label.style.display = 'none';
      });
      inchLabels.forEach(function(label) {
        label.style.display = '';
      });
      
      localStorage.setItem('unitPreference', 'imperial');
    }
    
    metricBtn.addEventListener('click', switchToMetric);
    imperialBtn.addEventListener('click', switchToImperial);
    
    const savedPreference = localStorage.getItem('unitPreference');
    if (savedPreference === 'imperial') {
      switchToImperial();
    } else {
      switchToMetric();
    }
    
    document.addEventListener('variant:update', function() {
      const currentPreference = localStorage.getItem('unitPreference');
      if (currentPreference === 'imperial') {
        switchToImperial();
      } else {
        switchToMetric();
      }
    });
  });
});